import { createFormHook, createFormHookContexts } from "@tanstack/react-form";
import { CountrySelect } from "@/app/_components/ContactSalesV2/components/CountrySelect";
import { FormCheckbox } from "@/app/_components/ContactSalesV2/components/FormCheckbox";
import { Input } from "@/app/_components/ContactSalesV2/components/Input";
import { PhoneInput } from "@/app/_components/ContactSalesV2/components/PhoneInput";
import { Select } from "@/app/_components/ContactSalesV2/components/Select";
import { Textarea } from "@/app/_components/ContactSalesV2/components/Textarea";

const { fieldContext, formContext } = createFormHookContexts();

/**
 * Shared TanStack form hook with all field components registered.
 * Each form uses only the components it needs — unused ones have no cost.
 */
export const { useAppForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    Input,
    Textarea,
    PhoneInput,
    CountrySelect,
    FormCheckbox,
    Select,
  },
  formComponents: {},
});
